<script>
import TwContainer from '@/components/generic/tw-container.vue'
import TwTransitionContainer from '@/components/generic/tw-transition-container.vue'
import FundraiserSupporters from '@/components/fundraisers/fundraiser-supporters.vue'
import FundraiserUpdatesViewPublic from '@/components/fundraisers/fundraiser-updates-view-public.vue'
import TwTabsNavigation from '@/components/generic/tabs/tw-tabs-navigation.vue'
import FundraiserTeamListGroupItem from '@/components/fundraisers/fundraiser-tabs/fundraiser-team-list-group-item.vue'

export default {
  name: 'FundraiserPageTabs',
  components: { FundraiserTeamListGroupItem, TwTabsNavigation, FundraiserUpdatesViewPublic, FundraiserSupporters, TwTransitionContainer },
  props: {
    fundraiserPage: {
      type: Object,
      required: true
    },
    fundraiser: {
      type: Object,
      default:null
    }
  },
  data() {
    return {
      ActiveTab: null
    }
  },
  computed: {
    tabs() {
      const tabs = [
        { name: 'About', slug: 'story', current: this.ActiveTab === 'story'},
      ]
      if(this.fundraiserPage.cached.donations_confirmed_count) {
        // tabs.push({ name: 'Supporters', slug: 'supporters', current: this.ActiveTab === 'supporters', badge: this.fundraiserPage.cached.donations_confirmed_count?? null })
      }
      if(this.fundraiserPage.cached.fundraiser_updates_count && this.fundraiserPage.cached.fundraiser_updates_count > 0) {
        tabs.push({ name: 'Updates', slug: 'updates', badge: this.fundraiserPage.cached.fundraiser_updates_count ?? null })
      }
      if(this.fundraiserPage.team) {
        tabs.push({ name: `Team ${this.fundraiserPage.team.name}`, slug: 'team'})
      }
      return tabs
    }
  },
  beforeMount() {
    if(this.$route.params.section) {
      this.ActiveTab = this.$route.params.section
    }
    else {
      this.ActiveTab = 'story'
    }
  }
}
</script>

<template>
  <div>
    <tw-tabs-navigation v-model="ActiveTab" :tabs="tabs" id-field="slug" />
    <tw-transition-container class="mt-6">
      <div v-if="ActiveTab === 'story'" class="flex gap-6">
        <div class="flex flex-col gap-3 font-lato fundraiser-description-container" v-html="fundraiserPage.long_description" />
      </div>
      <div v-else-if="ActiveTab === 'supporters'">
        <fundraiser-supporters :fundraiser="fundraiser" :fundraiser-page="fundraiserPage" />
      </div>
      <div v-else-if="ActiveTab === 'updates'">
        <fundraiser-updates-view-public :updatable-type="fundraiserPage.object_type" :updatable-id="fundraiserPage.id" />
      </div>
      <div v-if="ActiveTab === 'team'">
        <fundraiser-team-list-group-item :key="'fundraiser-page-team-' + fundraiserPage.id + '-' + fundraiserPage.team.id" always-expanded :team="fundraiserPage.team" />
      </div>
    </tw-transition-container>
  </div>
</template>

<style scoped>

</style>
